<nav class="nav">
  <ul class="routes">
    @for (item of routes; track $index) {
    <li>
      <a
        class="route"
        [routerLink]="item.link"
        [class.gray]="item.color === 'gray'"
        [class.yellow]="item.color === 'yellow'"
      >
        <svg-icon
          class="flex items-center justify-center s-12"
          [src]="item.icon"
        />
        @if (item.dollarSignIcon) {
        <svg-icon
          class="flex items-center justify-center s-12"
          [src]="'assets/icons/core/price.svg'"
        />
        }
        {{ item.title }}
      </a>
    </li>
    }
  </ul>

  <ul class="feature-routes">
    @if (affiliatesService.hasClaimableBonus()) {
    <li>
      <button
        type="button"
        (click)="handleOpenAffiliatesRewardModal()"
        class="feature-route ocean long"
      >
        <svg-icon
          class="flex items-center justify-center s-12"
          src="assets/icons/affiliates/affiliates-reward.svg"
        />
        <span class="flex items-center gap-2">
          Claim 1
          <app-balance-icon balance="skins" size="12" color="var(--ocean)" />
          and 3 Free Cases
        </span>
      </button>
    </li>
    }
    @for (item of featureRoutes(); track $index) { @if (!item.hide) {
    <li>
      @if(item.link) {
      <a
        class="feature-route"
        [class.green]="item.color === 'green'"
        [class.purple]="item.color === 'purple'"
        [class.yellow]="item.color === 'yellow'"
        [class.red]="item.color === 'red'"
        [class.ocean]="item.color === 'ocean'"
        [routerLink]="item.link"
      >
        @if (item.icon) {
        <svg-icon
          class="flex items-center justify-center s-12"
          [src]="item.icon"
        />
        }
        {{ item.title }}
      </a>
      } @if (item.action) {
      <button
        type="button"
        (click)="item.action()"
        class="feature-route"
        [class.green]="item.color === 'green'"
        [class.purple]="item.color === 'purple'"
        [class.yellow]="item.color === 'yellow'"
        [class.red]="item.color === 'red'"
        [class.ocean]="item.color === 'ocean'"
      >
        @if (item.icon) {
        <svg-icon
          class="flex items-center justify-center s-12"
          [src]="item.icon"
        />
        }
        {{ item.title }}
      </button>
      }
    </li>
    } }
  </ul>
</nav>
